import { createTheme } from "@mui/material/styles";

import logoMedic from "../assets/images/mediclogoblanco.png";
import logoCardio from "../assets/images/cardiologo.png";
import logoArgentina from "../assets/images/logoargentina.png";
import logoMastered from "../assets/images/masteredlogo.png";
import logoMaxsalud from "../assets/images/maxsalud.png";
import logoAmbulance from "../assets/images/ambulanceapp.png";

/**
 * Configuración de marca por `configuracion.destinatario`.
 * Reemplaza el ternario anidado que vivía en Barra.js.
 */
export const BRANDS = {
  1: { key: "medic", label: "Emergencias", color: "#D8261C", logo: logoMedic, logoHeight: 40 },
  2: { key: "cardio", label: "Cardiológico", color: "#E36D00", logo: logoCardio, logoHeight: 42 },
  3: { key: "argentina", label: "Argentina", color: "#1565C0", logo: logoArgentina, logoHeight: 42 },
  4: { key: "mastered", label: "Mastered", color: "#F57C00", logo: logoMastered, logoHeight: 42 },
  5: { key: "maxsalud", label: "Max Salud", color: "#D8261C", logo: logoMaxsalud, logoHeight: 42 },
  6: { key: "ambulance", label: "Ambulance", color: "#D8261C", logo: logoAmbulance, logoHeight: 42 },
};

export const DEFAULT_BRAND = {
  key: "default",
  label: "Ambulance",
  color: "#1F2937",
  logo: logoAmbulance,
  logoHeight: 42,
};

/** Devuelve la marca activa a partir del objeto `configuracion`. */
export function getBrand(configuracion) {
  if (!configuracion || configuracion.destinatario == null) return DEFAULT_BRAND;
  return BRANDS[configuracion.destinatario] || DEFAULT_BRAND;
}

/** Tema MUI centrado en el color de la marca activa. */
export function createBrandTheme(brand) {
  const accent = (brand && brand.color) || DEFAULT_BRAND.color;

  return createTheme({
    palette: {
      primary: { main: accent, contrastText: "#FFFFFF" },
      background: { default: "#F4F6F8" },
    },
    shape: { borderRadius: 10 },
    typography: {
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      button: { textTransform: "none", fontWeight: 600, letterSpacing: 0.2 },
    },
    components: {
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
            backdropFilter: "saturate(140%) blur(2px)",
          },
        },
      },
      MuiButton: {
        defaultProps: { disableElevation: true },
      },
    },
  });
}
